// extracted by mini-css-extract-plugin
export default {"videoPlayer2Contianer":"VideoPlayer2_videoPlayer2Contianer__WQsar"};